import { esc } from './sbchart.ts';

type RecordData = { seq: string; source: string; data?: unknown };
/** 医疗沿用已发布的展开键;其他来源同样按实体和真实记录编号保留。 */
export const historyRawKey = (kind: string, id: number, record: RecordData) => record.source === 'medical'
  ? `medical:${kind}:${id}:record:${record.seq}` : `historyRaw:${kind}:${id}:${record.source}:record:${record.seq}`;

/** 未展开不格式化/复制原始JSON;记录仍留在本页真实数据和完整下载中。 */
export function historyRawHTML(kind: string, id: number, record: RecordData, opened: ReadonlySet<string>): string {
  const key = historyRawKey(kind, id, record), open = opened.has(key);
  return `<details data-key="${esc(key)}" data-history-raw="${esc(kind)}:${id}"${open ? ' open' : ''}><summary>原始记录 #${esc(record.seq)}</summary>` +
    (open ? `<pre>${esc(JSON.stringify(record.data ?? {}, null, 2))}</pre>` : '') + '</details>';
}
